export const APP_STORE_URL =
  'https://apps.apple.com/us/app/klingua-2-0/id6469101880';

export const LANGUAGES = [
  { flag: '🇬🇧', name: 'English', native: 'English' },
  { flag: '🇨🇳', name: 'Chinese', native: '中文' },
  { flag: '🇹🇼', name: 'Chinese (TW)', native: '繁體中文' },
  { flag: '🇭🇰', name: 'Cantonese', native: '廣東話' },
  { flag: '🇰🇷', name: 'Korean', native: '한국어' },
  { flag: '🇯🇵', name: 'Japanese', native: '日本語' },
  { flag: '🇪🇸', name: 'Spanish', native: 'Español' },
  { flag: '🇫🇷', name: 'French', native: 'Français' },
  { flag: '🇮🇹', name: 'Italian', native: 'Italiano' },
];

export const STATS = [
  { n: '★ 5.0', l: 'App Store rating' },
  { n: '9', l: 'Languages' },
  { n: '< 1s', l: 'To translate' },
  { n: 'iOS 16+', l: 'iPhone & iPad' },
];
